import { Reducer } from 'redux';
import { DocumentActionTypes } from 'types/actions/document';
import { FileDocument } from 'types/reducers/document';
import { setStorageReadBlobToken } from 'utils/blob';

import { documentConstant } from '../actionTypes';

export type FileDocumentState = FileDocument & {
  selected?: boolean;
};

interface DocumentState {
  data: FileDocumentState[];
  total_item: number;
  total_page: number;
  loading: boolean;
  readBlobToken: {
    token: string;
    expire_in: number | null;
  };
}

const initialState: DocumentState = {
  data: [],
  total_item: 0,
  total_page: 0,
  loading: false,
  readBlobToken: {
    token: '',
    expire_in: null,
  },
};

const documentReducer: Reducer<DocumentState, DocumentActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case documentConstant.GET_FILES: {
      return {
        ...state,
        data: [],
      };
    }
    case documentConstant.FETCH_DATA_FILES:
      return {
        ...state,
        ...action.payload,
      };
    case documentConstant.UPDATE_SELECT_FILE:
      const { id } = action.payload;
      const newData = [...state.data];
      if (id) {
        const index = newData.findIndex((file) => file.id === id);
        if (index !== -1) {
          newData[index] = {
            ...newData[index],
            selected: newData[index]?.selected ? !newData[index] : true,
          };
        }
      }
      return {
        ...state,
        data: newData,
      };
    case documentConstant.SELECT_ALL_FILE:
      const tempData = state.data.map((file) => ({
        ...file,
        selected: action.payload,
      }));
      return {
        ...state,
        data: tempData,
      };
    case documentConstant.UPDATE_LOADING_STATUS:
      return {
        ...state,
        loading: action.payload,
      };
    case documentConstant.UPDATE_READ_TOKEN: {
      setStorageReadBlobToken(action.payload.token);
      return {
        ...state,
        readBlobToken: action.payload,
      };
    }

    default:
      return state;
  }
};

export default documentReducer;
